import { render, staticRenderFns } from "./field-checkbox.vue?vue&type=template&id=c396367a&scoped=true"
import script from "./field-checkbox.vue?vue&type=script&lang=js"
export * from "./field-checkbox.vue?vue&type=script&lang=js"
import style0 from "./field-checkbox.vue?vue&type=style&index=0&id=c396367a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c396367a",
  null
  
)

export default component.exports